import { gql } from '@apollo/client'

export const FETCH_UNA_LINK_MUTATION = gql`
	mutation fetchSclAssignmentLink {
		fetchSclAssignmentLink {
			assignmentLink
		}
	}
`
export const MANUAL_SYNC_PROVILDER = gql`
	mutation manualSyncSclToProvider {
		manualSyncSclToProvider {
			success
		}
	}
`
